import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VendorProAction } from "../../../Redux/action/VendorProAction";
import { VendorProfile as VendorProfileAction } from "../../../Redux/action/VendorProfileAction";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js/max";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../../utils/CropImg";
import { LocationForm } from "./locationData";
import "./VendorProfile.scss";

import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Divider,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  TextareaAutosize,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewProfile from "./ViewProfile";

const SectionWrapper = ({
  title,
  sectionKey,
  onSave,
  isSaveDisabled,
  children,
  editMode,
  setEditMode,
}) => {
  const inEdit = editMode[sectionKey];

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 3, mb: 3 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: "#286a94" }}>
          {title}
        </Typography>

        {!inEdit ? (
          <Button
            variant="outlined"
            size="small"
            sx={{
              textTransform: "uppercase",
              borderColor: "#286a94",
              color: "#286a94",
              "&:hover": {
                backgroundColor: "#286a94",
                color: "#fff",
                borderColor: "#286a94",
              },
            }}
            startIcon={<EditIcon />}
            onClick={() =>
              setEditMode((prev) => ({ ...prev, [sectionKey]: true }))
            }
          >
            Edit
          </Button>
        ) : (
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              disabled={isSaveDisabled}
              sx={{
                textTransform: "uppercase",
                backgroundColor: "#286a94",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#1e5474",
                },
              }}
              onClick={() => {
                onSave();
                setEditMode((prev) => ({ ...prev, [sectionKey]: false }));
              }}
            >
              Save
            </Button>

            <Button
              variant="outlined"
              color="error"
              onClick={() =>
                setEditMode((prev) => ({ ...prev, [sectionKey]: false }))
              }
            >
              Cancel
            </Button>
          </Stack>
        )}
      </Box>

      <Divider sx={{ mb: 2 }} />
      <Box>{children}</Box>
    </Paper>
  );
};

const VendorProfile = () => {
  const dispatch = useDispatch();
  const { userResult } = useSelector((state) => state.Auth);
  const id = userResult?.vendorid;
  const userInfo = useSelector((state) => state?.VendorProfile?.result);
  const [locations, setLocations] = useState([
    { country: "", city: "", state: "", address: "", locationType: "" },
  ]);

  const [errors, setErrors] = useState({});
  const [showOverlay, setShowOverlay] = useState(false);

  const [tempPro, setTempPro] = useState();
  const [cropModal, setCropModal] = useState(false);
  const [fileData, setFileData] = useState(); // company logo
  const [fileData2, setFileData2] = useState(); // profile image
  const [countryCode, setCountryCode] = useState("in");

  const [state, setState] = useState({
    vendorId: "",
    firstName: "",
    lastName: "",
    vendorEmailId: "",
    mobile: "",
    companyWebsite: "",
    vendorDesignation: "",
    city: "",
    state1: "",
    dialCode: "",
    country: "",
    address: "",
    description: "",
    experience: "",
    whatsApp: "",
    company: "",
    organizationEmailId: "",
    website: "",
    orgPhone: "",
    orgLocation: "",
    panNumber: "",
    gstNumber: "",
    governmentId: "",
    governmentTaxId: "",
    countryCode: "in",
  });

  const [panFile, setPanFile] = useState(null);
  const [gstFile, setGstFile] = useState(null);
  const [msaFile, setMsaFile] = useState(null);
  const [ndaFile, setNdaFile] = useState(null);
  const [msaFilePreview, setMsaFilePreview] = useState(null);
  const [ndaFilePreview, setNdaFilePreview] = useState(null);
  const [panFilePreview, setPanFilePreview] = useState(null);
  const [gstFilePreview, setGstFilePreview] = useState(null);

  const [governmentIdFile, setGovernmentIdFile] = useState(null);
  const [governmentIdPreview, setGovernmentIdPreview] = useState(null);

  const [governmentTaxIdFile, setGovernmentTaxIdFile] = useState(null);
  const [governmentTaxIdPreview, setGovernmentTaxIdPreview] = useState(null);

  const [uploadImageData, setUploadImageData] = useState({});
  const [currentTab, setCurrentTab] = useState("personal"); // "personal" | "company" | "documents"
  const [editMode, setEditMode] = useState({
    personal: false,
    company: false,
    documents: false,
  });

  const [showView, setShowView] = useState(true);

  // Cropper
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const { firstName, lastName, mobile, company } = state;
  const isIndian =
    (state?.countryCode || userInfo?.countryCode || "in").toLowerCase() ===
    "in";

  // ========= Fetch completion percentage =========
  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (id) {
  //       try {
  //         const res = await getPercentage(id);
  //         const percent = res?.data || 0;
  //         setProfilePercent(percent);
  //         if (percent === 100) {
  //           setIsSubmitted(true);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching percentage:", error);
  //       }
  //     }
  //   };
  //   fetchData();
  // }, [id]);

  // ========= Fetch profile =========
  useEffect(() => {
    if (id) {
      dispatch(VendorProfileAction(id));
    }
  }, [dispatch, id]);

  // ========= Initialize from userInfo =========
  useEffect(() => {
    if (!userInfo) return;

    setState((prev) => ({
      ...prev,
      vendorId: userInfo?.vendorId || "",
      firstName: userInfo?.firstName || "",
      lastName: userInfo?.lastName || "",
      vendorEmailId: userInfo?.email || "",
      mobile: userInfo?.mobile || "",
      companyWebsite: userInfo?.companyWebsite || "",
      vendorDesignation: userInfo?.designation || "",
      city: userInfo?.city || "",
      state: userInfo?.state || "",
      country: userInfo?.country || "",
      countryCode: userInfo?.countryCode || "in",
      dialCode: userInfo?.dialCode || "",
      address: userInfo?.address || "",
      description: userInfo?.description || "",
      experience: userInfo?.experience || "",
      whatsApp: userInfo?.whatsApp || "",
      company: userInfo?.company || "",
      organizationEmailId: "",
      website: "",
      orgPhone: "",
      orgLocation: "",
      gstNumber: userInfo?.gstNumber || "",
      panNumber: userInfo?.panNumber || "",
      governmentId: userInfo?.governmentId || "",
      governmentTaxId: userInfo?.governmentTaxId || "",
    }));

    setLocations(userInfo?.locations || []);

    setFileData(userInfo?.companyLogoUrl);
    setFileData2(userInfo?.vendorProfileImageUrl);
    setCountryCode(userInfo?.countryCode || "in");

    const handleUrlToPreviewOrFile = (url, setFile, setPreview) => {
      if (!url) return;
      const ext = url.split(".").pop()?.toLowerCase();
      if (["jpg", "jpeg", "png", "webp"].includes(ext)) {
        setPreview(url);
      } else {
        setFile(url);
      }
    };

    handleUrlToPreviewOrFile(
      userInfo?.msadocUrl,
      setMsaFile,
      setMsaFilePreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.ndadocUrl,
      setNdaFile,
      setNdaFilePreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.panImageUrl,
      setPanFile,
      setPanFilePreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.gstImageUrl,
      setGstFile,
      setGstFilePreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.governmentIdFileUrl,
      setGovernmentIdFile,
      setGovernmentIdPreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.governmentTaxIdFileUrl,
      setGovernmentTaxIdFile,
      setGovernmentTaxIdPreview
    );
  }, [userInfo]);

  // ========= Validation =========
  const validateFields = () => {
    const fieldErrors = {};
    const numberRegex = /\d/;

    if (!firstName) {
      fieldErrors.firstName = "First Name is required";
    } else if (numberRegex.test(firstName)) {
      fieldErrors.firstName = "First Name should not contain numbers";
    }

    if (!lastName) {
      fieldErrors.lastName = "Last Name is required";
    } else if (numberRegex.test(lastName)) {
      fieldErrors.lastName = "Last Name should not contain numbers";
    }

    if (!mobile) {
      fieldErrors.mobile = "Mobile number is required";
    }

    setErrors(fieldErrors);
    return Object.keys(fieldErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let cleanedValue = value?.toUpperCase()?.replace(/\s+/g, "");

    // First Name / Last Name
    if (name === "firstName" || name === "lastName") {
      const cleaned = value.replace(/[^A-Za-z]/g, "");
      setState((prev) => ({ ...prev, [name]: cleaned }));
      return;
    }

    // PAN NUMBER
    if (name === "panNumber") {
      const pan = cleanedValue.slice(0, 10);

      const panRegex = /^[A-Z]{0,5}[0-9]{0,4}[A-Z]?$/;
      if (panRegex.test(pan)) {
        setState((prev) => ({ ...prev, [name]: pan }));
      }
      return;
    }

    // GST NUMBER
    if (name === "gstNumber") {
      const gst = cleanedValue.slice(0, 15);

      if (/^[0-9A-Z]*$/.test(gst)) {
        setState((prev) => ({ ...prev, [name]: gst }));
      }
      return;
    }

    const cleanedText = value.replace(/[^A-Za-z ]/g, "");
    setState((prev) => ({ ...prev, [name]: cleanedText }));
  };

  const handleDeleteProfilePic = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    handleRemovePic();
  };

  const handleRemovePic = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      .custom-confirm-button {
        background-color: #286a94 !important;
        color: white;
        border-bottom: 1px solid rgb(57, 57, 57);
      }
      .custom-title {
        border-bottom: 0.5px solid #adadad;
        color: #286a94 !important;
        padding-bottom: 10px;
      }
      .msg-paragraph {
        margin-top:10px;
      }
    `;
    document.getElementsByTagName("head")[0].appendChild(style);

    const para = document.createElement("div");
    para.className = "custom-paragraph";
    para.innerText = "Are you sure you want to delete your profile picture?";

    const container = document.createElement("div");
    container.appendChild(para);

    Swal.fire({
      title: "Delete Image",
      html: container.outerHTML,
      showCancelButton: true,
      confirmButtonText: "Yes",
      customClass: {
        title: "custom-title",
        confirmButton: "custom-confirm-button",
      },
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios
            .put(
              `${process.env.REACT_APP_API_PATH}/ebench/remove_vendor_profile?vendorId=${id}`
            )
            .then(() => {
              toast.success("Image deleted successfully");
              setCroppedAreaPixels(null);
            });
          dispatch(VendorProfileAction(id));
        } catch (error) {
          console.error("Error accepting:", error);
          Swal.fire(
            "Error",
            "There was an error accepting the invitation",
            "error"
          );
        }
      }
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const filesize = file.size / 1024 / 1024;
    if (filesize > 2) {
      e.target.value = null;
      return toast.error(
        "Please upload a file larger than 4 KB and smaller than 2MB."
      );
    }

    setFileData(file);
    setUploadImageData({ companyLogo: file });
  };

  const onCropComplete = (croppedArea, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  };

  const handleProfileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileSize = file.size;
    const MIN_SIZE = 4 * 1024; // 4 KB
    const MAX_SIZE = 2 * 1024 * 1024; // 2 MB

    if (fileSize < MIN_SIZE) {
      toast.error("File size must be between 4 KB and 2 MB");
      e.target.value = null;
      return;
    }

    if (fileSize > MAX_SIZE) {
      toast.error("File size must be between 4 KB and 2 MB");
      e.target.value = null;
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setTempPro(reader.result);
      setCropModal(true);
      e.target.value = "";
    };
  };

  const handleCropSubmit = async () => {
    try {
      const croppedFile = await getCroppedImg(
        tempPro,
        croppedAreaPixels,
        "vendor_profile"
      );
      setFileData2(croppedFile);
      setCropModal(false);
    } catch (e) {
      console.error("Crop failed", e);
    }
  };

  const handleFileUpload = (event, setFile, setFilePreview) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileType = file.type.split("/")[0];
    const MAX_SIZE = 2 * 1024 * 1024; // 8MB

    if (file > MAX_SIZE) {
      return toast.error("File size must be between 4 KB and 2 MB");
    }

    if (fileType === "image" || file.type === "application/pdf") {
      setFile(file);
      if (fileType === "image") {
        setFilePreview(URL.createObjectURL(file));
      } else {
        setFilePreview(null);
      }
    } else {
      toast.error("Please upload only images or PDF files.");
    }
  };

  const handleDeleteFile = (setFile, setFilePreview, inputId) => {
    setFile(null);
    setFilePreview(null);
    const input = document.getElementById(inputId);
    if (input) input.value = null;
  };

  // ========= Submit Handlers =========
  const handleDocumentsSubmit = (e) => {
    if (e) e.preventDefault();

    if (isIndian && state?.panNumber) {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      if (!panRegex.test(state?.panNumber)) {
        return toast.error("Please enter a valid PAN number.");
      }
    }

    if (state?.gstNumber) {
      const gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9]{1}$/;
      if (!gstRegex.test(state?.gstNumber)) {
        return toast.error("Please enter a valid GST number.");
      }
    }

    if (!isIndian) {
      if (!state.governmentId || !state.governmentTaxId) {
        return toast.error(
          "Government ID and Tax ID are required for non-Indian vendors."
        );
      }
      if (!governmentIdFile && !governmentIdPreview) {
        return toast.error("Government ID document is required.");
      }
      if (!governmentTaxIdFile && !governmentTaxIdPreview) {
        return toast.error("Government Tax document is required.");
      }
    } else {
      if (!state.panNumber) {
        return toast.error("PAN Number is required for Indian vendors.");
      }
      if (!panFile && !panFilePreview) {
        return toast.error("PAN Document is required.");
      }
    }

    const isValid = validateFields();
    if (!isValid) return;

    const content = {
      ...state,
      countryCode: state?.countryCode,
      dialCode: state?.dialCode,
      governmentId: state.governmentId,
      governmentTaxId: state.governmentTaxId,
    };

    const formData = new FormData();
    let totalSize = 0;

    if (msaFile instanceof File) totalSize += msaFile.size;
    if (ndaFile instanceof File) totalSize += ndaFile.size;
    if (panFile instanceof File) totalSize += panFile.size;
    if (gstFile instanceof File) totalSize += gstFile.size;
    if (uploadImageData?.companyLogo instanceof File)
      totalSize += uploadImageData.companyLogo.size;
    if (fileData2 instanceof File) totalSize += fileData2.size;
    if (governmentIdFile instanceof File) totalSize += governmentIdFile.size;
    if (governmentTaxIdFile instanceof File)
      totalSize += governmentTaxIdFile.size;
    const MAX_SIZE = 8 * 1024 * 1024; // 8MB

    if (totalSize > MAX_SIZE) {
      return toast.error("Total file size should not exceed 8 MB.");
    }

    formData.append("vendor", JSON.stringify(content));
    if (msaFile) formData.append("msa", msaFile);
    if (ndaFile) formData.append("nda", ndaFile);
    if (panFile) formData.append("pan", panFile);
    if (gstFile) formData.append("gst", gstFile);
    if (governmentIdFile) formData.append("governmentIdFile", governmentIdFile);
    if (governmentTaxIdFile)
      formData.append("governmentTaxIdFile", governmentTaxIdFile);

    if (uploadImageData?.companyLogo)
      formData.append("companyLogo", uploadImageData.companyLogo);
    if (fileData2) formData.append("profileImage", fileData2);

    dispatch(VendorProAction(formData)).then((res) => {
      if (res?.data) {
        toast.success("Documents updated Successfully!");
        dispatch(VendorProfileAction(id));
        setShowView(true);
      }
    });
  };

  const handleProfileSubmit = (e) => {
    if (e) e.preventDefault();

    const pattern = /^[A-Za-z]+$/;
    if (!pattern.test(state?.firstName)) {
      toast.error("First name must contain only alphabetic characters");
      return;
    } else if (!pattern.test(state?.lastName)) {
      toast.error("Last name must contain only alphabetic characters");
      return;
    }

    let mobileNumber = mobile.replace(/\s+/g, "");

    if (mobileNumber.startsWith("0")) {
      mobileNumber = mobileNumber.substring(1);
    }

    const fullNumber = `+${state.dialCode}${mobileNumber}`;
    // console.log("Full Number:", fullNumber);
    if (!isValidPhoneNumber(fullNumber)) {
      toast.error("Invalid phone number");
      return;
    }

    if (firstName?.length < 2) {
      return toast.error("First name should be between 2-50 characters");
    }
    if (lastName?.length < 2) {
      return toast.error("Last name should be between 2-50 characters");
    }

    const content = {
      vendorId: state.vendorId,
      firstName: state.firstName,
      lastName: state.lastName,
      vendorEmailId: state.vendorEmailId,
      mobile: state.mobile,
      countryCode: state.countryCode,
      dialCode: state.dialCode,
    };

    const formData = new FormData();
    if (fileData2) formData.append("profileImage", fileData2);
    formData.append("vendor", JSON.stringify(content));

    dispatch(VendorProAction(formData)).then((res) => {
      if (res?.data) {
        toast.success("Personal details updated");
        dispatch(VendorProfileAction(id));
        setShowView(true);
      }
    });
  };

  const handleCompanySubmit = (e) => {
    if (e) e.preventDefault();

    const content = {
      vendorId: state.vendorId,
      companyWebsite: state.companyWebsite,
      company: state.company,
      description: state.description,
      locations: locations,
    };
    const formData = new FormData();
    if (uploadImageData?.companyLogo)
      formData.append("companyLogo", uploadImageData.companyLogo);
    formData.append("vendor", JSON.stringify(content));

    dispatch(VendorProAction(formData)).then((res) => {
      if (res?.data) {
        toast.success("Company details updated");
        dispatch(VendorProfileAction(id));
        setShowView(true);
      }
    });
  };

  // ========= Derived Valid Flags =========
  const hasMsa = msaFile || msaFilePreview;
  const hasNda = ndaFile || ndaFilePreview;

  const isPersonalDetailsValid =
    state?.firstName &&
    state?.lastName &&
    state?.vendorEmailId &&
    state?.mobile;

  const isCompanyDetailsValid =
    state?.company &&
    state?.companyWebsite &&
    locations[0]?.city &&
    locations[0]?.address &&
    locations[0]?.country &&
    locations[0]?.locationType &&
    state?.description;

  const isDocumentsValid = isIndian
    ? hasMsa && hasNda && state?.panNumber && (panFile || panFilePreview)
    : hasMsa &&
      hasNda &&
      state?.governmentId &&
      state?.governmentTaxId &&
      (governmentIdFile || governmentIdPreview) &&
      (governmentTaxIdFile || governmentTaxIdPreview);

  if (showView) {
    return <ViewProfile handleChange={() => setShowView(false)} />;
  }

  const PersonalSection = () => {
    const disabled = !editMode.personal;

    return (
      <>
        {/* Profile Picture */}
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Box
            sx={{
              width: 180,
              height: 180,
              borderRadius: "50%",
              overflow: "hidden",
              border: "2px solid #e0e0e0",
              position: "relative",
              cursor: disabled ? "default" : "pointer",
            }}
            onMouseOver={() => !disabled && setShowOverlay(true)}
            onMouseOut={() => !disabled && setShowOverlay(false)}
          >
            {fileData2 ? (
              <img
                src={
                  typeof fileData2 === "string"
                    ? fileData2
                    : URL.createObjectURL(fileData2)
                }
                alt="Profile"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                color="#417f9c"
              >
                <Typography variant="body2">Select Image</Typography>
              </Box>
            )}

            {showOverlay && !disabled && (
              <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                sx={{
                  bgcolor: "rgba(0,0,0,0.4)",
                  color: "white",
                  transition: "0.2s",
                }}
                onClick={() =>
                  !disabled && document.getElementById("fileInput")?.click()
                }
              >
                <Typography variant="body2">Choose Image</Typography>
              </Box>
            )}

            {showOverlay && fileData2 && !disabled && (
              <IconButton
                size="small"
                sx={{
                  position: "absolute",
                  bottom: 8,
                  right: "50%",
                  transform: "translateX(50%)",
                  bgcolor: "white",
                  border: "1px solid red",
                }}
                onClick={handleDeleteProfilePic}
              >
                <DeleteIcon color="error" />
              </IconButton>
            )}

            <input
              id="fileInput"
              type="file"
              name="file"
              onChange={handleProfileChange}
              accept=".jpg, .jpeg, .jfif, .pjpeg, .pjp, .png, .svg, .webp, .tiff, .heif"
              style={{ display: "none" }}
              disabled={disabled}
            />
          </Box>

          <Typography
            variant="caption"
            color="primary"
            mt={1}
            textAlign="center"
          >
            Please upload a file larger than 4 KB and smaller than 2 MB.
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="First Name"
              name="firstName"
              value={state.firstName}
              onChange={handleInputChange}
              fullWidth
              disabled={disabled}
              required
              inputProps={{ maxLength: 50, pattern: "^[A-Za-z]+$" }}
              error={!!errors.firstName}
              helperText={errors.firstName}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Last Name"
              name="lastName"
              value={state.lastName}
              onChange={handleInputChange}
              fullWidth
              disabled={disabled}
              required
              inputProps={{ maxLength: 50, pattern: "^[A-Za-z]+$" }}
              error={!!errors.lastName}
              helperText={errors.lastName}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Email"
              name="vendorEmailId"
              value={state.vendorEmailId}
              fullWidth
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display="flex" gap={1} alignItems="flex-end">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  marginLeft: "15px",
                  gap: 1,
                }}
              >
                <PhoneInput
                  inputClass="vendorProfilePhoneInput"
                  country={countryCode}
                  enableSearch
                  onChange={(value, countryData) => {
                    if (disabled) return;
                    const newDialCode = countryData?.dialCode || "";
                    const newCountryCode =
                      countryData?.countryCode?.toLowerCase() || "in";

                    setState((prevState) => ({
                      ...prevState,
                      dialCode: newDialCode,
                      countryCode: newCountryCode,
                    }));
                    setCountryCode(newCountryCode);

                    const cleanedValue = value.replace(/\D/g, "");
                    const local = cleanedValue.startsWith(newDialCode)
                      ? cleanedValue.slice(newDialCode.length)
                      : cleanedValue;

                    setState((prevState) => ({
                      ...prevState,
                      mobile: local,
                    }));
                  }}
                  disableCountryCode={false}
                  disableDropdown={false}
                  countryCodeEditable={false}
                  inputProps={{
                    readOnly: true,
                  }}
                  disabled={disabled}
                  style={{ width: "auto" }}
                />
                <TextField
                  type="number"
                  label="Mobile Number"
                  name="mobile"
                  value={state?.mobile}
                  onChange={(e) => {
                    if (disabled) return;
                    const inputValue = e.target.value.slice(0, 15);
                    setState((prev) => ({ ...prev, mobile: inputValue }));
                  }}
                  fullWidth
                  disabled={disabled}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  };

  const CompanySection = () => {
    const disabled = !editMode.company;

    return (
      <>
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} md={4}>
            <TextField
              label="Company Website"
              name="companyWebsite"
              value={state.companyWebsite}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Company Name"
              name="company"
              value={company}
              onChange={handleInputChange}
              fullWidth
              required
              disabled={disabled}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginLeft: 2,
                borderRadius: 2,
                p: 2,
              }}
            >
              <Button
                variant="contained"
                size="small"
                component="label"
                startIcon={<CloudUploadIcon />}
                disabled={disabled}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#286a94",
                  "&:hover": { backgroundColor: "#1f5676" },
                }}
              >
                Upload Logo
                <input
                  hidden
                  type="file"
                  accept=".jpg, .jpeg, .png, .svg, .webp, .tiff, .heif"
                  onChange={handleFileChange}
                />
              </Button>

              <Box
                sx={{
                  width: 75,
                  height: 75,
                  borderRadius: 2,
                  border: "1px solid #ccc",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {fileData ? (
                  <>
                    <img
                      src={
                        typeof fileData === "string"
                          ? fileData
                          : URL.createObjectURL(fileData)
                      }
                      alt="Company Logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                    {!disabled && (
                      <IconButton
                        size="small"
                        onClick={() => setFileData(null)}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          bgcolor: "#fff",
                          boxShadow: 1,
                          "&:hover": { bgcolor: "#ffe5e5" },
                        }}
                      >
                        {/* Remove icon intentionally hidden */}
                      </IconButton>
                    )}
                  </>
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      color: "#999",
                      textAlign: "center",
                      p: 1,
                    }}
                  >
                    No Logo
                  </Box>
                )}
              </Box>
            </Box>

            <Typography variant="caption" color="red" mt={1}>
              Allowed formats: JPG, PNG — Min size: 4K - Max size: 2MB.
            </Typography>
          </Grid>
        </Grid>

        <Box mb={2}>
          <LocationForm
            locations={locations}
            setLocations={setLocations}
            disabled={!editMode.company}
          />
        </Box>

        <Box>
          <Typography
            variant="subtitle2"
            fontWeight={500}
            mb={0.5}
            sx={{ color: "#286a94" }}
          >
            Description *
          </Typography>

          <TextareaAutosize
            name="description"
            placeholder="Describe your company..."
            value={state.description}
            onChange={handleInputChange}
            minRows={4}
            maxLength={1500}
            disabled={disabled}
            style={{
              width: "100%",
              resize: "vertical",
              fontSize: "14px",
              padding: "12px",
              borderRadius: "8px",
              background: disabled ? "#f5f5f5" : "#fff",
              border: "1px solid #b5c8d3",
              outline: "none",
              transition: "border-color 0.2s ease, box-shadow 0.2s ease",
            }}
            className="styled-textarea"
          />

          <Typography
            variant="caption"
            sx={{
              textAlign: "right",
              display: "block",
              mt: 0.5,
              color: "#6b6b6b",
            }}
          >
            {state.description?.length || 0}/1500
          </Typography>
        </Box>

        <Typography
          variant="caption"
          color="#286a94"
          mt={2}
          display="block"
          textAlign="center"
        >
          Please upload a file larger than 4 KB and smaller than 2 MB.
        </Typography>
      </>
    );
  };

  const DocumentsSection = () => {
    const disabled = !editMode.documents;

    return (
      <>
        <Grid container spacing={2}>
          {/* Indian fields */}
          {isIndian && (
            <>
              <Grid item xs={12} md={6}>
                <TextField
                  label="PAN Number"
                  name="panNumber"
                  placeholder="ABCDE1234F"
                  value={state?.panNumber}
                  onChange={(e) => {
                    let value = e.target.value.toUpperCase();

                    // Allow only up to 10 characters
                    if (value.length > 10) return;

                    // Pattern for partial typing
                    const partialRegex = /^[A-Z]{0,5}[0-9]{0,4}[A-Z]?$/;

                    if (partialRegex.test(value)) {
                      handleInputChange({
                        target: { name: "panNumber", value },
                      });
                    }
                  }}
                  fullWidth
                  required
                  disabled={userInfo?.isDocumentUploadLocked || disabled}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="GST Number (Optional)"
                  name="gstNumber"
                  placeholder="22AAAAA9999A1Z5"
                  value={state?.gstNumber}
                  fullWidth
                  disabled={
                    (userInfo?.isDocumentUploadLocked && userInfo?.gstNumber) ||
                    disabled
                  }
                  onChange={handleInputChange}
                />
              </Grid>
            </>
          )}

          {/* Non-Indian Fields */}
          {!isIndian && (
            <>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Government ID Number"
                  name="governmentId"
                  value={state.governmentId}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  disabled={userInfo?.isDocumentUploadLocked || disabled}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Government Tax ID"
                  name="governmentTaxId"
                  value={state.governmentTaxId}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  disabled={userInfo?.isDocumentUploadLocked || disabled}
                />
              </Grid>
            </>
          )}

          {/* MSA */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" display="block" mb={0.5}>
              MSA Document{" "}
              <span style={{ marginLeft: "4px", color: "red" }}>*</span>
            </Typography>
            <input
              className="form-control"
              id="msaDocument"
              type="file"
              name="msaDocument"
              accept=".pdf, .jpg, .jpeg, .png"
              onChange={(e) =>
                handleFileUpload(e, setMsaFile, setMsaFilePreview)
              }
              required={!(msaFile || msaFilePreview)}
              disabled={userInfo?.isDocumentUploadLocked || disabled}
            />
            {msaFilePreview && (
              <Box mt={1} textAlign="center">
                <a
                  href={msaFilePreview}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={msaFilePreview}
                    alt="MSA Document Preview"
                    style={{
                      width: "100%",
                      maxHeight: "100px",
                      objectFit: "contain",
                    }}
                  />
                </a>
                {!userInfo?.isDocumentUploadLocked && !disabled && (
                  <IconButton
                    size="small"
                    sx={{ mt: 1 }}
                    onClick={() =>
                      handleDeleteFile(
                        setMsaFile,
                        setMsaFilePreview,
                        "msaDocument"
                      )
                    }
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                )}
              </Box>
            )}
            {msaFile && !msaFilePreview && (
              <Box mt={1} textAlign="center">
                <Typography variant="body2" fontWeight={600}>
                  {msaFile?.name ?? "View document"}
                </Typography>
                <IconButton
                  onClick={() =>
                    msaFile?.name
                      ? window.open(URL.createObjectURL(msaFile), "_blank")
                      : msaFile && window.open(msaFile, "_blank")
                  }
                >
                  <VisibilityIcon color="primary" />
                </IconButton>
                {!userInfo?.isDocumentUploadLocked && !disabled && (
                  <IconButton
                    onClick={() =>
                      handleDeleteFile(
                        setMsaFile,
                        setMsaFilePreview,
                        "msaDocument"
                      )
                    }
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                )}
              </Box>
            )}
          </Grid>

          {/* GST doc */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" display="block" mb={0.5}>
              GST Document (Optional)
            </Typography>
            <input
              className="form-control"
              id="gstDocument"
              type="file"
              name="gstDocument"
              accept=".pdf, .jpg, .jpeg, .png"
              disabled={
                (userInfo?.gstImageUrl && userInfo?.isDocumentUploadLocked) ||
                disabled
              }
              onChange={(e) =>
                handleFileUpload(e, setGstFile, setGstFilePreview)
              }
            />
            {gstFilePreview && (
              <Box mt={1} textAlign="center">
                <a
                  href={gstFilePreview}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={gstFilePreview}
                    alt="GST Document Preview"
                    style={{
                      width: "100%",
                      maxHeight: "100px",
                      objectFit: "contain",
                    }}
                  />
                </a>
                {(!userInfo?.gstImageUrl ||
                  !userInfo?.isDocumentUploadLocked) &&
                  !disabled && (
                    <IconButton
                      size="small"
                      sx={{ mt: 1 }}
                      onClick={() =>
                        handleDeleteFile(
                          setGstFile,
                          setGstFilePreview,
                          "gstDocument"
                        )
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
              </Box>
            )}
            {gstFile && !gstFilePreview && (
              <Box mt={1} textAlign="center">
                <Typography variant="body2" fontWeight={600}>
                  {gstFile?.name ?? "View document"}
                </Typography>
                <IconButton
                  onClick={() =>
                    gstFile?.name
                      ? window.open(URL.createObjectURL(gstFile), "_blank")
                      : gstFile && window.open(gstFile, "_blank")
                  }
                >
                  <VisibilityIcon color="primary" />
                </IconButton>
                {(!userInfo?.gstImageUrl ||
                  !userInfo?.isDocumentUploadLocked) &&
                  !disabled && (
                    <IconButton
                      onClick={() =>
                        handleDeleteFile(
                          setGstFile,
                          setGstFilePreview,
                          "gstDocument"
                        )
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
              </Box>
            )}
          </Grid>

          {/* NDA */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" display="block" mb={0.5}>
              NDA Document{" "}
              <span style={{ marginLeft: "4px", color: "red" }}>*</span>
            </Typography>
            <input
              className="form-control"
              id="ndaDocument"
              type="file"
              name="ndaDocument"
              accept=".pdf, .jpg, .jpeg, .png"
              onChange={(e) =>
                handleFileUpload(e, setNdaFile, setNdaFilePreview)
              }
              required={!(ndaFile || ndaFilePreview)}
              disabled={userInfo?.isDocumentUploadLocked || disabled}
            />
            {ndaFilePreview && (
              <Box mt={1} textAlign="center">
                <a
                  href={ndaFilePreview}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={ndaFilePreview}
                    alt="NDA Document Preview"
                    style={{
                      width: "100%",
                      maxHeight: "100px",
                      objectFit: "contain",
                    }}
                  />
                </a>
                {!userInfo?.isDocumentUploadLocked && !disabled && (
                  <IconButton
                    size="small"
                    sx={{ mt: 1 }}
                    onClick={() =>
                      handleDeleteFile(
                        setNdaFile,
                        setNdaFilePreview,
                        "ndaDocument"
                      )
                    }
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                )}
              </Box>
            )}
            {ndaFile && !ndaFilePreview && (
              <Box mt={1} textAlign="center">
                <Typography variant="body2" fontWeight={600}>
                  {ndaFile?.name ?? "View document"}
                </Typography>
                <IconButton
                  onClick={() =>
                    ndaFile?.name
                      ? window.open(URL.createObjectURL(ndaFile), "_blank")
                      : ndaFile && window.open(ndaFile, "_blank")
                  }
                >
                  <VisibilityIcon color="primary" />
                </IconButton>
                {!userInfo?.isDocumentUploadLocked && !disabled && (
                  <IconButton
                    onClick={() =>
                      handleDeleteFile(
                        setNdaFile,
                        setNdaFilePreview,
                        "ndaDocument"
                      )
                    }
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                )}
              </Box>
            )}
          </Grid>

          {/* PAN or Government Tax Document */}
          {isIndian ? (
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" display="block" mb={0.5}>
                PAN Document{" "}
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              </Typography>
              <input
                className="form-control"
                id="panDocument"
                type="file"
                name="panDocument"
                accept=".pdf, .jpg, .jpeg, .png"
                onChange={(e) =>
                  handleFileUpload(e, setPanFile, setPanFilePreview)
                }
                required={!(panFile || panFilePreview)}
                disabled={userInfo?.isDocumentUploadLocked || disabled}
              />
              {panFilePreview && (
                <Box mt={1} textAlign="center">
                  <a
                    href={panFilePreview}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={panFilePreview}
                      alt="PAN Document Preview"
                      style={{
                        width: "100%",
                        maxHeight: "100px",
                        objectFit: "contain",
                      }}
                    />
                  </a>
                  {!userInfo?.isDocumentUploadLocked && !disabled && (
                    <IconButton
                      size="small"
                      sx={{ mt: 1 }}
                      onClick={() =>
                        handleDeleteFile(
                          setPanFile,
                          setPanFilePreview,
                          "panDocument"
                        )
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
                </Box>
              )}
              {panFile && !panFilePreview && (
                <Box mt={1} textAlign="center">
                  <Typography variant="body2" fontWeight={600}>
                    {panFile?.name ?? "View document"}
                  </Typography>
                  <IconButton
                    onClick={() =>
                      panFile?.name
                        ? window.open(URL.createObjectURL(panFile), "_blank")
                        : panFile && window.open(panFile, "_blank")
                    }
                  >
                    <VisibilityIcon color="primary" />
                  </IconButton>
                  {!userInfo?.isDocumentUploadLocked && !disabled && (
                    <IconButton
                      onClick={() =>
                        handleDeleteFile(
                          setPanFile,
                          setPanFilePreview,
                          "panDocument"
                        )
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
                </Box>
              )}
            </Grid>
          ) : (
            <>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" display="block" mb={0.5}>
                  Government ID Document{" "}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
                <input
                  type="file"
                  id="govIdDoc"
                  accept=".pdf, .jpg, .jpeg, .png"
                  disabled={disabled}
                  onChange={(e) =>
                    handleFileUpload(
                      e,
                      setGovernmentIdFile,
                      setGovernmentIdPreview
                    )
                  }
                />
                {governmentIdPreview && (
                  <Box mt={1} textAlign="center">
                    <img
                      src={governmentIdPreview}
                      alt="Government ID"
                      style={{
                        width: "100%",
                        maxHeight: 100,
                        objectFit: "contain",
                      }}
                    />
                    {!disabled && (
                      <IconButton
                        onClick={() =>
                          handleDeleteFile(
                            setGovernmentIdFile,
                            setGovernmentIdPreview,
                            "govIdDoc"
                          )
                        }
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    )}
                  </Box>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" display="block" mb={0.5}>
                  Government Tax Document
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
                <input
                  type="file"
                  id="govTaxDoc"
                  accept=".pdf, .jpg, .jpeg, .png"
                  disabled={disabled}
                  onChange={(e) =>
                    handleFileUpload(
                      e,
                      setGovernmentTaxIdFile,
                      setGovernmentTaxIdPreview
                    )
                  }
                />

                {governmentTaxIdPreview && (
                  <Box mt={1} textAlign="center">
                    <img
                      src={governmentTaxIdPreview}
                      alt="Government Tax Doc"
                      style={{
                        width: "100%",
                        maxHeight: 100,
                        objectFit: "contain",
                      }}
                    />
                    {!disabled && (
                      <IconButton
                        onClick={() =>
                          handleDeleteFile(
                            setGovernmentTaxIdFile,
                            setGovernmentTaxIdPreview,
                            "govTaxDoc"
                          )
                        }
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    )}
                  </Box>
                )}
              </Grid>
            </>
          )}
        </Grid>

        <Typography
          variant="caption"
          color="#286a94"
          mt={2}
          display="block"
          textAlign="center"
        >
          Please upload a file larger than 4 KB and smaller than 2 MB.
        </Typography>
      </>
    );
  };

  // ================== MAIN RETURN ==================
  return (
    <>
      {/* Crop Dialog */}
      <Dialog
        open={cropModal}
        onClose={() => setCropModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Crop Profile</DialogTitle>
        <DialogContent sx={{ height: 400 }}>
          <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
            <Cropper
              image={tempPro}
              crop={crop}
              cropShape="round"
              zoom={zoom}
              aspect={1}
              showGrid={false}
              restrictPosition={false}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
              objectFit="cover"
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="contained"
            color="success"
            onClick={handleCropSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          my: 3,
          px: 2,
        }}
      >
        {/* Sidebar */}
        <Paper
          elevation={3}
          sx={{
            width: 260,
            borderRadius: 3,
            p: 2,
            height: "auto",
            position: "sticky",
            top: 80,
          }}
        >
          <Typography
            variant="h6"
            color="#286a94"
            fontWeight={700}
            textAlign="center"
            mb={2}
          >
            Vendor Profile
          </Typography>

          <Stack spacing={1.2}>
            {[
              {
                key: "personal",
                label: "Personal Details",
                valid: !!isPersonalDetailsValid,
              },
              {
                key: "company",
                label: "Company Details",
                valid: !!isCompanyDetailsValid,
              },
              {
                key: "documents",
                label: "Documents",
                valid: !!isDocumentsValid,
              },
            ].map((s) => {
              const isActive = currentTab === s.key;
              const inEdit = editMode[s.key];
              return (
                <Box
                  key={s.key}
                  onClick={() => setCurrentTab(s.key)}
                  sx={{
                    cursor: "pointer",
                    borderRadius: 2,
                    px: 1.5,
                    py: 1.2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    transition: "0.2s",
                    bgcolor: isActive ? "#286a94" : "#ffffff",
                    color: isActive ? "#ffffff" : "#286a94",
                    border: isActive ? "none" : "1px solid #cdd8df",
                    "&:hover": {
                      bgcolor: isActive ? "#1f5575" : "#e8f2f7",
                      borderColor: "#286a94",
                    },
                  }}
                >
                  <Typography fontSize={14} fontWeight={500}>
                    {s.label}
                  </Typography>
                  {inEdit ? (
                    <Tooltip title="Editing">
                      <EditIcon
                        fontSize="small"
                        sx={{ color: isActive ? "#fff" : "#286a94" }}
                      />
                    </Tooltip>
                  ) : s.valid ? (
                    <Tooltip title="Completed">
                      <CheckCircleIcon
                        fontSize="small"
                        sx={{ color: isActive ? "#fff" : "#2e7d32" }}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Pending">
                      <AccessTimeIcon
                        fontSize="small"
                        sx={{ color: isActive ? "#fff" : "#ed6c02" }}
                      />
                    </Tooltip>
                  )}
                </Box>
              );
            })}
          </Stack>
        </Paper>

        {/* Main content */}
        <Box sx={{ flex: 1 }}>
          {currentTab === "personal" && (
            <SectionWrapper
              title="Personal Details"
              sectionKey="personal"
              onSave={handleProfileSubmit}
              isSaveDisabled={!isPersonalDetailsValid}
              editMode={editMode}
              setEditMode={setEditMode}
            >
              {PersonalSection()}
            </SectionWrapper>
          )}
          {currentTab === "company" && (
            <SectionWrapper
              title="Company Details"
              sectionKey="company"
              onSave={handleCompanySubmit}
              isSaveDisabled={!isCompanyDetailsValid}
              editMode={editMode}
              setEditMode={setEditMode}
            >
              {CompanySection()}
            </SectionWrapper>
          )}
          {currentTab === "documents" && (
            <SectionWrapper
              title="Documents"
              sectionKey="documents"
              onSave={handleDocumentsSubmit}
              isSaveDisabled={!isDocumentsValid}
              editMode={editMode}
              setEditMode={setEditMode}
            >
              {DocumentsSection()}
            </SectionWrapper>
          )}
        </Box>

        {/* Right Notes Pane */}
        <Paper
          elevation={3}
          className="jc_notes_container"
          sx={{ p: 2, borderRadius: 3, minWidth: 260, maxWidth: 280 }}
        >
          <Typography
            color={"#286a94"}
            variant="subtitle1"
            fontWeight={700}
            mb={1.5}
          >
            Important Notes
          </Typography>
          <Divider />
          <Box mt={2} className="jc_notes">
            <Typography variant="body2" mb={1}>
              AI That Understands Hiring: eBench uses intelligent algorithms to
              match you with the right candidates—fast, accurately, and with
              zero guesswork.
            </Typography>
            <Typography variant="body2" mb={1}>
              Vetted Professionals Only: Every candidate is thoroughly assessed
              for skills, experience, and fit—saving you time and ensuring
              quality.
            </Typography>
            <Typography variant="body2" mb={1}>
              All-in-One Hiring Platform: Post jobs, manage candidates, schedule
              interviews, and onboard—all from one intuitive dashboard.
            </Typography>
            <Typography variant="body2" mb={1}>
              Reduce Time & Cost: Cut hiring time by up to 70% and avoid the
              costs of bad hires with data-backed decision-making.
            </Typography>
            <Typography variant="body2" mb={1}>
              Global Reach, Local Compliance: Find top remote talent while
              ensuring full compliance with employment laws across regions.
            </Typography>
            <Typography variant="body2" mb={1}>
              Custom Workflows: Tailor the platform for every industry and
              internal hiring processes—whether you're a startup or a large
              enterprise.
            </Typography>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default VendorProfile;
